/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import PropTypes from 'prop-types';
import memoizeLast from 'transmute/memoizeLast';
import compose from 'transmute/compose';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import emptyFunction from 'react-utils/emptyFunction';

// @ts-expect-error module not typed
import CalleeErrorBoundary from './callee-error/CalleeErrorBoundary';
import CRMEmbeddedMessage from './crm-embedded/components/CRMEmbeddedMessage';
import NoCalleesPrompt from './callee-numbers/components/NoCalleesPrompt';
import CallSettingsNumbersActivityCreator from './callee-numbers/components/CallSettingsNumbersActivityCreator';
// @ts-expect-error module not typed
import EnsureCallingAccess from './calling-appeals/components/EnsureCallingAccess';
import { getData, isSucceeded } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getCallableObjects, getPhoneNumberProperties, getHasAssociatedObjects, getCallablePhoneNumberProperties } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import CallingOnboardingActivityCreator from './callee-numbers/components/CallingOnboardingActivityCreator';
// @ts-expect-error module not typed
import withCalleeOmnibus from './callee-omnibus/hoc/withCalleeOmnibus';
import withCallingAccess from './calling-appeals/hoc/withCallingAccess';
import withWidgetState from './widget-state/hoc/withWidgetState';
// @ts-expect-error module not typed
import withAccessLevelPrefetch from './access-level/hoc/withAccessLevelPrefetch';
import { getIsCRMEmbedded } from './utils/getIsCRMEmbedded';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CallNumbersActivityCreatorPopover__Wrapper",
  componentId: "w55jdh-0"
})(["max-width:615px;"]);
const Options = styled.div.withConfig({
  displayName: "CallNumbersActivityCreatorPopover__Options",
  componentId: "w55jdh-1"
})([".option-item:hover{background-color:", ";}"], CALYPSO_LIGHT);
const CallNumbersActivityCreatorPopover = props => {
  const hasCallableRecords = memoizeLast(calleesData => {
    const hasAssociatedObjects = getHasAssociatedObjects(calleesData);
    if (hasAssociatedObjects) {
      return true;
    }
    const callableObjects = getCallableObjects(calleesData);
    return callableObjects && callableObjects.some(callableObject => {
      const phoneNumberProperties = getPhoneNumberProperties(callableObject);
      return getCallablePhoneNumberProperties(phoneNumberProperties).size > 0;
    });
  });
  const renderCRMEmbeddedMessage = () => {
    const {
      subjectId,
      objectTypeId
    } = props;
    return /*#__PURE__*/_jsx(CRMEmbeddedMessage, {
      subjectId: subjectId,
      objectTypeId: objectTypeId
    });
  };
  const renderNoCalleesMessage = () => {
    const {
      objectTypeId,
      subjectId
    } = props;
    return /*#__PURE__*/_jsx(NoCalleesPrompt, {
      subjectId: Number(subjectId),
      objectTypeId: objectTypeId,
      shouldShowAddNumber: false
    });
  };
  const renderCallees = () => {
    const {
      appIdentifier,
      onCallButtonClick,
      objectTypeId,
      asyncCalleeOmnibus,
      asyncSettingsOmnibus,
      widgetState,
      selectedCallProvider,
      selectedFromNumber,
      scopes,
      limits
    } = props;
    const calleeOmnibusData = getData(asyncCalleeOmnibus);
    const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
    const hasRecords = hasCallableRecords(calleesData);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: !isSucceeded(asyncCalleeOmnibus) || hasRecords ? /*#__PURE__*/_jsx(Options, {
        className: "flex-column",
        "data-selenium-test": "call-settings-numbers-options",
        children: /*#__PURE__*/_jsx(CallSettingsNumbersActivityCreator, {
          appIdentifier: appIdentifier,
          asyncCalleeOmnibus: asyncCalleeOmnibus,
          asyncSettingsOmnibus: asyncSettingsOmnibus,
          defaultFromNumber: selectedFromNumber,
          limits: limits,
          objectTypeId: objectTypeId,
          onCallButtonClick: onCallButtonClick,
          scopes: scopes,
          selectedCallProvider: selectedCallProvider,
          widgetState: widgetState
        })
      }) : renderNoCalleesMessage()
    });
  };
  const {
    appIdentifier,
    scopes,
    limits,
    asyncSettingsOmnibus,
    callingAccess
  } = props;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(CalleeErrorBoundary, {
      appName: "CALLING",
      children: /*#__PURE__*/_jsx(EnsureCallingAccess, {
        appIdentifier: appIdentifier,
        useFullWidth: false,
        scopes: scopes,
        callingAccess: callingAccess,
        children: /*#__PURE__*/_jsx(CallingOnboardingActivityCreator, {
          asyncSettingsOmnibus: asyncSettingsOmnibus,
          scopes: scopes,
          limits: limits,
          appIdentifier: appIdentifier,
          children: /*#__PURE__*/_jsx("div", {
            className: "flex-column",
            children: getIsCRMEmbedded() ? renderCRMEmbeddedMessage() : renderCallees()
          })
        })
      })
    })
  });
};
CallNumbersActivityCreatorPopover.proptypes = {
  appIdentifier: PropTypes.string.isRequired,
  asyncCalleeOmnibus: RecordPropType('AsyncCalleeOmnibusResult').isRequired,
  asyncSettingsOmnibus: RecordPropType('AsyncSettingsOmnibusResult').isRequired,
  callingAccess: RecordPropType('CallingAccess').isRequired,
  limits: ImmutablePropTypes.map.isRequired,
  objectTypeId: PropTypes.string.isRequired,
  onCallButtonClick: PropTypes.func,
  scopes: ImmutablePropTypes.map.isRequired,
  selectedCallProvider: RecordPropType('CallingProvider'),
  selectedFromNumber: RecordPropType('FromNumber'),
  subjectId: PropTypes.string.isRequired,
  widgetState: ImmutablePropTypes.map.isRequired
};
CallNumbersActivityCreatorPopover.defaultProps = {
  onCallButtonClick: emptyFunction
};
export default compose(withCalleeOmnibus, withCallingAccess, withWidgetState, withAccessLevelPrefetch)(CallNumbersActivityCreatorPopover);